var map = {
	"./clockbeats-orchestra/feature-small.jpg": 95,
	"./clockbeats/feature-small.jpg": 100,
	"./fearless/feature-small.jpg": 101,
	"./next-generation/feature-small.jpg": 126,
	"./red-theater/feature-small.jpg": 128,
	"./tedx/feature-small.jpg": 130
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 418;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*\/feature\-small\.jpg$
// module id = 418
// module chunks = 0